// extracted by mini-css-extract-plugin
export var dividerContainer = "_76-0";
export var line = "_76-1";